import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Textarea as TextAreaComponent } from '@/ui/atoms/Textarea'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'
import { TextAreaField } from '@/payload-types'
import { FormLabel } from '@/ui/atoms/FormLabel'
import { useFormContext } from 'react-hook-form'
export const Textarea: React.FC<
  TextAreaField & {
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
    register: UseFormRegister<FieldValues>
    rows?: number
    showLabelAndDescription?: boolean
  }
> = ({
  name,
  defaultValue,
  description,
  icon,
  errors,
  label,
  register,
  required = false,
  rows = 3,
  width,
  showLabelAndDescription = true,
}) => {
  const { setValue, watch } = useFormContext()
  const value = watch(name)

  return (
    <Width width={width ?? 100}>
      <FormLabel
        htmlFor={name}
        description={description}
        useNormalFontColor={showLabelAndDescription}
      >
        {label}
      </FormLabel>
      <TextAreaComponent
        name={name}
        placeholder={!value ? defaultValue?.toString() : undefined}
        id={name}
        rows={rows}
        required={required ?? false}
        hasError={errors[name] ? true : false}
      />
      {errors[name] && <Error />}
    </Width>
  )
}
